<template>
  <div class="container">
    <div class="daily_tab">
      <img @click="handleBack" style="width: 0.32rem; height: 0.59rem" src="../assets/back.png" />
      <div>伟小班的日报</div>
    </div>
    <div class="report_search">
      <div>{{ currentMonthStr }}</div>
      <div class="end_date">数据截止时间：{{ currentDateStr }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date(),
      currentDateStr: this.handleTime(new Date()),
      currentMonth: new Date(),
      currentMonthStr: this.getCurrentMonth(new Date()),
    }
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
    getCurrentMonth(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1);
    },
    handleTime(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1) + "-" + this.checkTime(date.getDate());
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
  }
}
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.81rem;
  background: #f9f9f9;
  position: relative;
  padding-top: 1.71rem;
}
.daily_tab {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.daily_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.report_search {
  height: 1.2rem;
  margin-top: 12px;
  background-color:#ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4rem;
}
</style>